export const categories = [
  {
    slug: "romance",
    name: "明星恋情",
    desc: "同框、探班、官宣与辟谣，感情线话题一次看全",
    icon: "ri-heart-3-line",
    count: 268,
    image:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20with%20two%20overlapping%20warm%20coral%20rings%20intersecting%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20clean%20modern%20composition%2C%20soft%20diffused%20studio%20lighting&width=900&height=700&seq=gw-cat-romance-2026&orientation=landscape",
  },
  {
    slug: "works",
    name: "作品动态",
    desc: "开机、定档、路透与预告，追剧追片不掉队",
    icon: "ri-film-line",
    count: 214,
    image:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20abstract%20film%20strip%20and%20geometric%20shapes%20in%20amber%20gold%20and%20deep%20teal%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=900&height=700&seq=gw-cat-works-2026&orientation=landscape",
  },
  {
    slug: "variety",
    name: "综艺名场面",
    desc: "救场、名场面、金句与翻车瞬间全收录",
    icon: "ri-mic-line",
    count: 176,
    image:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20with%20concentric%20sound%20wave%20circles%20and%20spark%20shapes%20in%20warm%20coral%20amber%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=900&height=700&seq=gw-cat-variety-2026&orientation=landscape",
  },
  {
    slug: "fashion",
    name: "时尚造型",
    desc: "红毯、机场私服与同款穿搭，造型讨论聚集地",
    icon: "ri-t-shirt-line",
    count: 158,
    image:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20abstract%20fabric%20ribbons%20and%20torn%20paper%20layers%20in%20coral%20rose%20and%20amber%20gold%20on%20cream%20background%2C%20halftone%20texture%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=900&height=700&seq=gw-cat-fashion-2026&orientation=landscape",
  },
  {
    slug: "stage",
    name: "偶像舞台",
    desc: "演唱会、巡演返场与直拍名场面速览",
    icon: "ri-star-line",
    count: 142,
    image:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20with%20abstract%20spotlight%20beam%20and%20starburst%20shapes%20in%20deep%20teal%20amber%20gold%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=900&height=700&seq=gw-cat-stage-2026&orientation=landscape",
  },
  {
    slug: "industry",
    name: "行业观察",
    desc: "档期复盘、赛道变化与内容趋势的冷静解读",
    icon: "ri-line-chart-line",
    count: 96,
    image:
      "https://readdy.ai/api/search-image?query=bold%20editorial%20magazine%20collage%20illustration%20of%20abstract%20bar%20chart%20blocks%20and%20grid%20lines%20in%20warm%20coral%20deep%20teal%20on%20cream%20paper%20texture%2C%20halftone%20dots%2C%20energetic%20pop%20art%20poster%20style%2C%20no%20text%2C%20no%20people%2C%20soft%20studio%20lighting&width=900&height=700&seq=gw-cat-industry-2026&orientation=landscape",
  },
];